import React from 'react';

const ResumeSection = () => {
  return (
    <section id="resume">
      <div className="container">
        <div className="section-label">03 — Resume</div>
        <div className="resume-grid reveal">
          <div className="resume-col">
            <h3>Experience</h3>
            <div className="resume-entry">
              <div className="resume-role">
                Senior Developer —
                <a href="https://ymcawichita.org" target="_blank" rel="noopener noreferrer" className="resume-link"> Greater Wichita YMCA / YMCA 360</a>
              </div>
              <div className="resume-meta">February 2026 - Present</div>
              <div className="resume-desc">
                YMCA 360 is an on-demand fitness and wellness platform. I am working in the Ruby on Rails backend.
              </div>
              <div className="resume-tech">Rails, RSpec, PostgreSQL, Bootstrap, Docker, AWS</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">
                Developer (Contract) —
                <a href="https://www.flinthillsgroup.com/" target="_blank" rel="noopener noreferrer" className="resume-link"> Flint Hills Group</a>
              </div>
              <div className="resume-meta">August 2025 - December 2025</div>
              <div className="resume-desc">
                Delivered custom software projects with Ruby on Rails, React, Expo / React Native, and MySQL.
              </div>
              <div className="resume-tech">Rails, React, TypeScript, Expo, React Native, GraphQL, MySQL</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">
                billbolte.com
              </div>
              <div className="resume-meta">September 2025</div>
              <div className="resume-desc">Personal portfolio site built and maintained in modern React and TypeScript.</div>
              <div className="resume-tech">React, TypeScript, Tailwind CSS, Devicons React</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">
                PHP Developer (Contract) —
                <a href="https://hightouchtechnologies.com/" target="_blank" rel="noopener noreferrer" className="resume-link"> High Touch, Inc.</a>
              </div>
              <div className="resume-meta">November 2024 - March 2025</div>
              <div className="resume-desc">
                Added features and fixed bugs on a PHP ecommerce application used in the rent-to-own industry.
              </div>
              <div className="resume-tech">PHP, CodeIgniter, jQuery, Bootstrap, MySQL, Apache</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">Ruby on Rails Developer (Contract) — Appointment Launch</div>
              <div className="resume-meta">January 2024 - March 2024</div>
              <div className="resume-desc">
                Converted an older Rails codebase to Rails 7 for Optical Launch, added features, and optimized PostgreSQL.
              </div>
              <div className="resume-tech">Rails 7, PostgreSQL, Bootstrap, jQuery</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">
                Senior Software Engineer —
                <a href="https://worktorch.io/" target="_blank" rel="noopener noreferrer" className="resume-link"> WorkTorch</a>
              </div>
              <div className="resume-meta">December 2021 - August 2023</div>
              <div className="resume-desc">
                Developed WorkTorch web applications across Node.js and React. Improved performance through schema optimization,
                enhanced GraphQL APIs, built KPI reporting, and integrated remote HRIS APIs.
              </div>
              <div className="resume-tech">Node.js, React, TypeScript, PostgreSQL, GraphQL, Sequelize, AWS</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">
                Software Development Supervisor —
                <a href="https://hightouchtechnologies.com/" target="_blank" rel="noopener noreferrer" className="resume-link"> High Touch, Inc.</a>
              </div>
              <div className="resume-meta">February 2006 - November 2021</div>
              <div className="resume-desc">
                Managed a web/mobile development team for rent-to-own products. Built customer portals with PHP/CodeIgniter,
                API layers in Rails/PostgreSQL, and mobile apps using Ionic/Angular.
              </div>
              <div className="resume-tech">PHP, CodeIgniter, Rails, MySQL, PostgreSQL, Ionic, Angular, Apache</div>
            </div>

            <div className="resume-entry">
              <div className="resume-role">Ruby on Rails Developer (Contract) — Visibility Optics LLC</div>
              <div className="resume-meta">June 2017 - October 2017</div>
              <div className="resume-desc">
                Wrote Rails code for a patient education and eyewear platform now known as Appointment Launch.
              </div>
              <div className="resume-tech">Rails, PostgreSQL, Git, Bitbucket, DigitalOcean</div>
            </div>
          </div>

          <div className="resume-col">
            <h3>Education</h3>
            <div className="resume-entry">
              <div className="resume-role">
                B.S. Computer Programming Technology —
                <a href="https://www.sckans.edu/" target="_blank" rel="noopener noreferrer" className="resume-link"> Southwestern College</a>
              </div>
              <div className="resume-meta">Graduated December 2003</div>
              <div className="resume-desc">Winfield, Kansas</div>
            </div>

            <h3 className="resume-subheader">Certifications</h3>
            <div className="resume-entry">
              <div className="resume-role">Certified ScrumMaster</div>
              <div className="resume-meta">Professional certification</div>
              <div className="resume-desc">Applied in Agile environments while mentoring junior developers and leading teams.</div>
            </div>

            <a href="/files/Bill-Bolte-Resume.pdf" className="resume-cta" target="_blank" rel="noopener noreferrer">
              ↓ Download full resume
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResumeSection;

